import React, { useState } from 'react'
import LoginForm from './LoginForm'
import ForgotPassword from './ForgotPassword'
import ChangePassword from './ResetPassword'
import SignUp from './SignUp'
import { BrowserRouter as Router, Route, Switch, useHistory, useLocation } from 'react-router-dom'

import './login.scss'

const TitleDisplay = ({ signUpStep, forgotPasswordSuccess }) => {
  const location = useLocation()

  const getTitleByRoute = () => {
    if (location.pathname === '/sign-up') {
      return signUpStep === 2 ? '' : 'Sign up to get started'
    }
    if (location.pathname === '/forgot-password' && forgotPasswordSuccess) {
      return ''
    }
    const routeTitles = {
      '/login': 'Sign in to continue',
      '/forgot-password': 'Forgot Password',
      '/resetpassword': ' ',
      '/sign-up': 'Sign up to get started'
    }
    return routeTitles[location.pathname] || 'Sign in to continue'
  }

  return <div className='auth__container__right__title'>{getTitleByRoute()}</div>
}

const Login = () => {
  const [message, setMessage] = useState()
  const [signUpStep, setSignUpStep] = useState(1)
  const [forgotPasswordSuccess, setForgotPasswordSuccess] = useState(false)
  const history = useHistory()

  const changeRoute = (route) => {
    history.push(route)
  }

  const handleSignUpStepChange = (step) => {
    setSignUpStep(step)
  }

  const handleForgotPasswordSuccessChange = (isSuccess) => {
    setForgotPasswordSuccess(isSuccess)
  }

  return (
    <>
      <div className='container auth'>

        <div className='auth__container__left'>
          <div className='auth__container__left__header-icon'>
            <img src={`/${window.appName}/images/auth-screen-header-icon.png`} alt='Servify' />
          </div>
          <div className='auth__container__left__title f32'>
            Central Management System
          </div>
          <div className='auth__container__left__image'>
            <img src={`/${window.appName}/images/auth-screen-main.png`} alt='Servify' />
          </div>
          <div className='auth__container__left__description text-center f16'>
            Uniting people, processes, and tech <br />
            for customer-centric solutions!
          </div>
        </div>
        <div className='auth__container__right'>
          <div className='auth__box'>
            <div className='auth__box__form'>
              <div className='auth__box__form--header text-center'>
                <img src={`/${window.appName}/images/servify_logo.svg`} alt='Servify' />
              </div>
              <Router>
                <TitleDisplay signUpStep={signUpStep} forgotPasswordSuccess={forgotPasswordSuccess} />
                <div className='auth__box__form--body'>
                  <Switch>
                    <Route exact path='/login'>
                      <LoginForm setMainSuccessMsg={setMessage} resetSuccessMsg={message} changeRoute={changeRoute} />
                    </Route>
                    <Route exact path='/forgot-password'>
                      <ForgotPassword setMainSuccessMsg={setMessage} resetSuccessMsg={message} changeRoute={changeRoute} onSuccessChange={handleForgotPasswordSuccessChange} />
                    </Route>
                    <Route exact path='/resetpassword'>
                      <ChangePassword setMainSuccessMsg={setMessage} resetSuccessMsg={message} changeRoute={changeRoute} />
                    </Route>
                    <Route exact path='/sign-up'>
                      <SignUp setMainSuccessMsg={setMessage} resetSuccessMsg={message} changeRoute={changeRoute} onStepChange={handleSignUpStepChange} />
                    </Route>
                  </Switch>
                </div>
              </Router>
              <div className='auth__box__form--footer text-center'>
                <img src={`/${window.appName}/images/poweredBy.svg`} alt='Servify' />
              </div>
            </div>
          </div>
        </div>



      </div>
    </>
  )
}

export default Login
